import EpsilonLayout from './EpsilonLayout'

export default EpsilonLayout
